export interface Job<DataType = unknown, ProgressType = unknown> {
  id: string
  createdAt: number
  state: JobState
  data: DataType
  error?: Error
  progress?: ProgressType
  waitingOnTimestampMs?: number
  activeOnTimestampMs?: number
  progressOnTimestampMs?: number
  failedOnTimestampMs?: number
  completedOnTimestampMs?: number
  isCancelled?: boolean
  batchJobId?: string
}

export enum JobState {
  Active = 'active',
  Waiting = 'waiting',
  Failed = 'failed',
  Completed = 'completed',
  Unknown = 'unknown',
}

export const isJobStateFinished = (state: JobState): boolean =>
  state === JobState.Failed || state === JobState.Completed

export const isJobFinished = (job: Job): boolean =>
  isJobStateFinished(job.state)
